import React from 'react';
import {Card, Pagination} from "antd";
import AddressLink from "../AddressLink";

export class CompaniesView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      pageSize: 12,
    }
  }

  componentDidMount() {
    const { onMount } = this.props;
    if (onMount) onMount();
  }

  componentDidUpdate(prevProps) {
    const { page, pageSize } = this.state;
    const { contacts } = this.props;
    const { contacts: prevItems } = prevProps;
    if (contacts !== prevItems && ((page - 1) * pageSize) > contacts.length) {
      this.setState({ page: 1 });
    }
  }

  setPagination = (page, pageSize) => {
    this.setState({ page });
  };

  setPageSize = (current, size) => {
    this.setState({ pageSize: size });
  };

  render() {
    const { companies, extras } = this.props;
    const { page, pageSize } = this.state;
    const itemsCut = companies.slice((page - 1) * pageSize, page * pageSize);
    return (
      <div>
        <div className='contacts-header'>
          <Pagination
            total={companies.length}
            showTotal={(total, range) => `${range[0]}-${range[1]} of ${total} items`}
            current={page}
            onChange={this.setPagination}
            pageSize={pageSize}
            hideOnSinglePage
          />
        </div>
        <div className='contacts-body'>
          {itemsCut.map(company => {
            let computedExtras = extras ? extras(company) : null;
            return (
              <Card className='company-card-flex' extra={computedExtras} title={company.companyname}>
                <div className='company-card-flex-body'>
                  <div className='company-card-flex-info'>
                    <AddressLink
                      address={{
                        street: [company.address, company.address2].join('\n'),
                        city: company.city,
                        state: company.state,
                        zip: company.zip
                      }}
                    />
                  </div>
                </div>
              </Card>
            );
          })}
        </div>
        <div className='contacts-footer'>
          <Pagination
            total={companies.length}
            showTotal={(total, range) => `${range[0]}-${range[1]} of ${total} items`}
            current={page}
            onChange={this.setPagination}
            pageSize={pageSize}
            hideOnSinglePage
          />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Boilerplate/CompaniesView.js